<script setup lang="ts">
import type { UIColor } from "@align/ui";
import type { BreadcrumbItem } from "~/composables/stores/breadcrumbs";

defineProps({
  breadcrumbs: {
    type: Array as PropType<BreadcrumbItem[]>,
    required: true,
  },

  colorForeground: {
    type: String as PropType<UIColor>,
    required: true,
  },
});

const emit = defineEmits<{ (event: "click-item", breadcrumb: BreadcrumbItem): void }>();
</script>
<template>
  <div style="display: flex">
    <div v-for="(breadcrumb, index) in breadcrumbs" :key="index" :class="$style.row">
      <BreadcrumbItem
        :title="breadcrumb.label"
        :icon="breadcrumb.icon"
        :color="colorForeground"
        :active="breadcrumb.active"
        :to="breadcrumb.to"
        @click="() => emit('click-item', breadcrumb)"
      />

      <div style="display: inline-flex; margin: auto 0.25rem; opacity: 0.4">
        <Icon v-if="breadcrumbs.length - 1 > index" id="chevron_right" size="large" :color="colorForeground" />
      </div>
    </div>
  </div>
</template>
<style module>
.row {
  display: inline-flex;
  align-items: center;
}
</style>
